export default function initQuicksearch() {
    const ACTIVE_CLASS = 'is-search-open';

    const $container = document.querySelector('.page-header');
    //const $trigger = $container.querySelector('.js-toggle-search');
    const $close = $container.querySelector('.js-close-search');

    const $input = $container.querySelector('.searchview-input');
    const $submit = $container.querySelector('.js-submit-search');

    /*const showSearch = () => {
        document.body.classList.add(ACTIVE_CLASS);
        setTimeout(() => {
            $input.focus();
        }, 200);
    };*/

    const hideSearch = () => {
        document.body.classList.contains(ACTIVE_CLASS) && document.body.classList.remove(ACTIVE_CLASS);
        setTimeout(() => {
            $input.blur();
            $input.value = '';
        }, 100);
    };

    const submitSearch = () => {
        window.location.href = `${$input.dataset.action}?q=${encodeURIComponent($input.value.replace(/ /g, '+'))}`;
    };

    /*$trigger.addEventListener('click', event => {
        event.preventDefault();
        showSearch();
    });*/

    $close.addEventListener('click', event => {
        event.preventDefault();
        hideSearch();
    });

    document.addEventListener('keyup', event => {
        if (event.key === 'Escape') {
            hideSearch();
        }
    });

    $input.addEventListener('keyup', event => {
        if (event.key === 'Enter') {
            submitSearch();
        }
    });

    $submit.addEventListener('click', event => {
        event.preventDefault();
        submitSearch();
    });

    document.addEventListener('click', event => {
        const $mainNavigationSearchView = document.querySelector('.main-navigation-searchview');
        if (($mainNavigationSearchView !=null) && (!$mainNavigationSearchView.contains(event.target))
            && (!event.target.classList.contains('js-toggle-search'))
        ) {
            hideSearch();
        }
    });
}
